import { z } from 'zod'

// Strapi(hcms) v4 의 REST 응답 봉투. 콘텐츠 항목은 `{ id, attributes }` 로 싸여 오고, 목록은
// `meta.pagination` 을 함께 싣는다. Swagger 를 내지 않는 서버라 생성 타입이 없어 봉투도 여기서 정의한다.
export const strapiItemSchema = <Attributes extends z.ZodType>(attributes: Attributes) =>
  z.object({ id: z.number(), attributes })

export type StrapiItem<Attributes> = { id: number; attributes: Attributes }

// 요청 함수가 본문을 벗기려고 받는 봉투. 본문 검증은 adapter 가 한다.
export type StrapiEnvelope<Data> = {
  data: Data
  meta?: { pagination?: unknown }
}

export const strapiPaginationSchema = z.object({
  page: z.number(),
  pageSize: z.number(),
  pageCount: z.number(),
  total: z.number(),
})

export const strapiPageSchema = <Attributes extends z.ZodType>(attributes: Attributes) =>
  z.object({
    data: z.array(strapiItemSchema(attributes)),
    meta: z.object({ pagination: strapiPaginationSchema }),
  })

// 요청 쿼리. Strapi 의 필터 문법은 깊은 객체라 그대로 넘기고, 직렬화는 앱 클라이언트(qs)가 한다.
export type StrapiQuery = {
  sort?: string[]
  filters?: Record<string, unknown>
  pagination?: { page?: number; pageSize?: number; limit?: number }
}

// 검증을 마친 뒤 `{ id, ...attributes }` 로 펼친다. lenient 가 넘긴 raw 에서도 죽지 않게 attributes 부재를 견딘다.
export const flattenStrapiItem = <Attributes extends object>(
  item: StrapiItem<Attributes>,
): { id: number } & Attributes => ({ ...item.attributes, id: item.id })

// 마지막 쪽 판정. 결과가 없으면 pageCount 가 0 이라 page(1) 와 같아지지 않으므로 이상(>=)으로 본다.
export const isLastStrapiPage = (pagination: z.infer<typeof strapiPaginationSchema> | undefined) =>
  !pagination || pagination.page >= pagination.pageCount
